import API from "../../Api";
import {
  DeliveryCharge,
  DeliveryChargeRequestBody,
  getDeliveryDetails,
} from "./DeliveryModels";
import { encryptJson } from "../..//utils/react-ec-utils";
import { createRequest } from "../../utils/hmac-utils";

export async function getDeliveryChargeAPI(payload: DeliveryChargeRequestBody) {
  const normalizedDeliveryProviderId = String(payload.deliveryProviderId ?? "")
    .trim()
    .replace(/^'+|'+$/g, "");

  const requestPayload: DeliveryCharge = {
    pickupDetails: payload.pickupDetails,
    dropDetails: payload.dropDetails,
    locationId: payload.locationId,
    deliveryProviderId: normalizedDeliveryProviderId,
    receiverDetails:payload.receiverDetails,
    senderDetails: payload.senderDetails,
    customerId: payload.customerId ?? "",
    addressId: payload.addressId ?? "",
    tip: Math.floor(payload.tip),
    emailId: payload.emailId ?? "",
    mobileNo: payload.mobileNo ?? "",
  };
  
  // const data = encryptJson(requestPayload);
  const ecnLocationProviderId = encodeURIComponent(encryptJson(normalizedDeliveryProviderId));
   const hmacRequest = await createRequest(requestPayload);

  return API({
    method: "post",
    url: `/api/customers/delivery/quote?deliveryProviderId=${ecnLocationProviderId}`,
    // data:{"data":hmacRequest}
    data : hmacRequest
  });
}

export async function dunzoOrderTrackingAPI(payload: getDeliveryDetails) {
  const data = {
    deliveryProviderId: payload?.DeliveryProviders,
    orderId: payload?.orderId,
    emailId: payload?.emailId ?? "",
    mobileNo: payload?.mobileNo ?? "",
  };
  // const payloadData = encryptJson(data);
   const hmacRequest = await createRequest(data);
  return API({
    method: "post",
    url: `/api/customers/delivery/status/v2`,
    // data: {"data": hmacRequest}
        data : hmacRequest
  });
}

// Instore Valet app tracking
export function getValetLocation(deliveryStaffId: string) {
  return API({
    method: "get",
    url: `/valet/getValetLocation?deliveryStaffId=${deliveryStaffId}`,
  });
}
